import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWallpaper = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V13H5V19H11V21H5ZM13 21V19H19V13H21V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H13ZM6 17L9 13L11.25 16L14.25 12L18 17H6ZM3 11V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H11V5H5V11H3ZM19 11V5H13V3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V11H19ZM15.5 10C15.0667 10 14.7083 9.85833 14.425 9.575C14.1417 9.29167 14 8.93333 14 8.5C14 8.06667 14.1417 7.70833 14.425 7.425C14.7083 7.14167 15.0667 7 15.5 7C15.9333 7 16.2917 7.14167 16.575 7.425C16.8583 7.70833 17 8.06667 17 8.5C17 8.93333 16.8583 9.29167 16.575 9.575C16.2917 9.85833 15.9333 10 15.5 10Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgWallpaper);
export default ForwardRef;
